import { service } from "@server/client";
import type {
  SetDeliveryOptionMutation,
  SetDeliveryOptionMutationVariables,
} from "@server/gql/graphql";
import { setDeliveryOptionMutation } from "@server/queries/checkout";

export const setDeliveryOption = async (
  variables: SetDeliveryOptionMutationVariables,
) => {
  try {
    const response = await service<
      SetDeliveryOptionMutation,
      SetDeliveryOptionMutationVariables
    >({
      query: setDeliveryOptionMutation,
      variables,
    });

    return response.setDeliveryOption;
  } catch (error: Error | unknown) {
    throw error;
  }
};
